



















const { AgGridVue } = require('ag-grid-vue');
import Confirmation from '@/components/Confirmation.vue';
import { ComponenteBase } from '@/views/base/ComponenteBase';
import { Funcionalidades } from '@/config/funcionalidades';
import { fetchConfiguracionStreamax } from './fetchConfiguracionStreamax';
import { LoadingService } from '@/services/loadingService';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import {
  codigoAccionesMenuItem,
  CodigoAccion,
  PermisoAccion,
} from '@/views/base/VariablesPermisos';
@Component({
  components: {},
})
export default class EstadoCamaras extends Vue {
  @Prop({ default: {} }) selectedValue: any;
  funcionalidad: Funcionalidades = Funcionalidades.Streamax;
  localeText: any = {};
  checkAllPatent: boolean = false;
  currentEvent: any = null;
  openDialog: boolean = false;
  map: google.maps.Map = null;
  loadingService = new LoadingService();
  cssMap: {} = {
    cursor: 'pointer',
    display: 'flex',
    'align-items': 'center',
    'justify-content': 'flex-start',
  };
  // infoWindow = new google.maps.InfoWindow({
  //   disableAutoPan: true,
  // });
  listDashboard: { title: string; value: any; key: any }[] = [];
  searchInput: string = '';
  accionDashboard: PermisoAccion = {
    accionCodigo: CodigoAccion.detallesDashboard,
    visible: false,
  };
  accionesTotales: PermisoAccion[] = [this.accionDashboard];
  message: any;
  date: any;
  $snotify: any;
  mounted() {
    this.loadingService.showLoading();
    this.getDashboardCamera();
  }
  isUndefined(value: any): string {
    return value == undefined ? '0' : value;
  }
  async getDashboardCamera() {
    this.loadingService.showLoading();
    let url = new URL(window.location.href);
    fetchConfiguracionStreamax(
      { id_camara: this.selectedValue },
      'configCamaras/estadoCamaras'
    )
      .then((response: any) => {
        if (response.data.CODIGO_RESPUESTA == '1') {
          console.log(response.data.data.jalerta);
          this.message = response.data.data.jalerta.mensaje;
          this.date = response.data.data.fecha_ult_movimiento;
          console.log(this.message);
        } else {
          this.$snotify.error(response.data.MENSAJE_RESPUESTA);
        }
      })
      .catch((error: any) => {
        console.log(error);
        this.$snotify.error('Error al obtener las estadoCamaras');
      })
      .finally(() => {
        this.loadingService.hideLoading();
      });
  }
}
